// THE MESSAGE UNDER "Delete this property?" ON `/home` (WALK-FIX-2, R238). APPROVED.
//
// The app's confirmation says "This removes "{title}" and its {n} saved appeal(s) from this device. This can't be undone."
// (PropertiesTab.swift:70-73). On the website the property is deleted from the ACCOUNT — its appeals are the server's —
// so "from this device" would be false here, and the website's line changes only that phrase.
// APPROVED (Tyler, 2026-10-05: "yes on deleting word"; docs/legal/WEB_PURCHASE_POLICIES.md on main), word for word.

/** The approval this sentence carries. */
export const DELETE_PROPERTY_APPROVAL = { by: "Tyler", on: "2026-10-05", quote: "yes on deleting word" } as const;

/** The approved message, with the app's own `{title}`, `{n}` and appeal/appeals choice. */
export const DELETE_PROPERTY_MESSAGE =
  "This removes \"{title}\" and its {n} saved {appeals} from your account. This can't be undone.";

/** The message for one property. */
export function deletePropertyMessage(title: string, appeals: number): string {
  return DELETE_PROPERTY_MESSAGE
    .replace("{title}", title)
    .replace("{n}", String(appeals))
    .replace("{appeals}", appeals === 1 ? "appeal" : "appeals");
}
